import { Regions } from './user';

export const ETHICS_FIELDS = [
  'REGULATORY_ETHICS',
  'BEHAVIORAL_ETHICS',
] as const;

export type EthicsField = (typeof ETHICS_FIELDS)[number];

export const RegionToAudience = {
  [Regions.CAN]: 'CA',
  [Regions.USA]: 'US',
  [Regions.GBR]: 'GB',
  global: 'Global',
};
